const prodArr = 
  [
    {
      product: "Art Canvas",
      dims: [
        "3300px x 3900px",
        "5700px x 6900px",
        "8100px x 9900px"
      ],
      opts: [
  		'8" x 10"',
        '16" x 20"',
        '24" x 30"'
      ],
      opt: "0",
      dpi: "300",
      orientation: "both"
    },{
      product: "Tapestry",
      dims: [
        "2550px x 4050px",
        "5100px x 6000px",
        "6816px x 8016px",
        "8100px x 9525px",
      ],
      opts: [
  		'Small 17" x 27"',
        'Medium 34" x 40"',
        'Large 50" x 60"',
        'Extra Large 60" x 80"',
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Acrylic Box",
      dims: [
        "1087px x 1087px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Acrylic Tray",
      dims: [
        "4368px x 3375px",
        "4368px x 3375px",
        "2325px x 1796px"
      ],
      opts: [
        "Gold Handles",
  		"Medium",
        "Small"
      ],
      opt: "0",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Art Print And Hanger",
      dims: [
        "1680px x 2100px",
        "2400px x 3000px",
        "3300px x 4200px",
        "4800px x 6000px",
        "3600px x 3600px",
        "6000px x 6000px",
        "9000px x 9000px",
        "9000px x 12000px",
        "12000px x 18000px",
      ],
      opts: [
        '8" x 10" (Printed area 5x7)',
        '11" x 14" (Printed area 8x10)',
        '16" x 20" (Printed area 11x14)',
        '18" x 24" (Printed area 16x20)',
        '12" x 12" (Printed area 12x12)',
        '20" x 20" (Printed area 20x20)',
        '30" x 30" (Printed area 30x30)',
        '30" x 40" (Printed area 26x33)',
        '40" x 60" (Printed area 36x50)',
      ],
      opt: "1",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Art Print",
      dims: [
        "1680px x 2100px",
        "2400px x 3000px",
        "3300px x 4200px",
        "4800px x 6000px",
      ],
      opts: [
  		'8" x 10" (Printed area 5x7)',
        '11" x 14" (Printed area 8x10)',
        '16" x 20" (Printed area 11x14)',
        '18" x 24" (Printed area 16x20)',
      ],
      opt: "0",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Framed Art Print",
      dims: [
        "1800px x 2400px",
        "2400px x 3300px",
        "3000px x 4800px",
        "3600px x 4800px",
        "4200px x 6000px",
        "5400px x 9000px"
      ],
      opts: [
  		'8" x 10"',
        '11" x 14"',
        '13" x 19"',
        '16" x 20"',
        '18" x 24"',
        '24" x 36"'
      ],
      opt: "2",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Bench",
      dims: [
        "8000px x 3600px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Blackout Window Curtain",
      dims: [
        "1800px x 1800px"
      ],
      opts: [
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Coaster Set",
      dims: [
        "1000px x 1000px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Coffee Mug",
      dims: [
        "2700px x 1120px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Coffee Table",
      dims: [
        "5340px x 2655px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape",
    },
    {
      product: "Comforter",
      dims: [
        "8640px x 8640px",
        "6720px x 8640px",
        "6720pxpx x 8640px",
        "7680px x 7680px",
        "10176px x 8640px",
      ],
      opts: [
  		'Queen',
        'Twin',
        'Twin xL',
        'Full',
        'King',
      ],
      opt: "1",
      dpi: "96",
      orientation: "both"
    },
    {
      product: "Counter Stool",
      dims: [
        "2628px x 2628px"
      ],
      opts: [
  		
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Cutting Board Rectangle",
      dims: [
        "1650px x 2475px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Cutting Board Round",
      dims: [
        "1800px x 1800px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Cutting Board Square",
      dims: [
        "1800px x 1800px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Duvet Cover",
      dims: [
        "8640px x 8640px",
        "6720px x 8640px",
        "6720pxpx x 8640px",
        "7680px x 7680px",
        "10176px x 8640px",
      ],
      opts: [
  		'Queen',
        'Twin',
        'Twin xL',
        'Full',
        'King',
      ],
      opt: "1",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Face Mask",
      dims: [
        "1256px x 1181px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Fleece Throw Blanket",
      dims: [
        "7875px x 9375px",
        "9375px x 12375px"
      ],
      opts: [
  		'Medium 60" x 50"',
        'Large 80" x 60"'
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Framed Wall Art",
      dims: [
        "1950px x 2438px",
        "2700px x 3376px",
        "3450px x 4313px",
        "4650px x 5814px",
        "3450px x 3450px",
        "5850px x 5850px",
        "8850px x 8850px",
      ],
      opts: [
  		'8" x 9.5"',
        '11" x 13"',
        '14" x 16.5"',
        '19" x 22.4"',
        '12" x 12"',
        '20" x 20"',
        '30" x 30"',
      ],
      opt: "1",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Memory Foam Bath Mat",
      dims: [
        "5925px x 3825px",
      ],
      opts: [
        
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Oblong Throw Pillow",
      dims: [
        "2450px x 3100px",
        "2750px x 3500px"
      ],
      opts: [
  		'23" x 14"',
        '26" x 16"',
      ],
      opt: "0",
      dpi: "100",
      orientation: "landscape"
    },
    {
      product: "Pillow Shams",
      dims: [
        "5850px x 3450px"
      ],
      opts: [
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Pouch",
      dims: [
        "1500px x 975px",
        "2100px x 1425px"
      ],
      opts: [
  		'Small',
        'Large',
      ],
      opt: "0",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Rectangular Tray",
      dims: [
        "5250px x 4050px",
        "6600px x 5100px"
      ],
      opts: [
  		'L',
        'xL'
      ],
      opt: "0",
      dpi: "300",
      orientation: "landscape"
    },
    {
      product: "Shower Curtain",
      dims: [
        "5184px x 5472px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "portrait"
    },
    {
      product: "Shower Curtain And Mat",
      dims: [
        "5184px x 5472px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "portrait"
    },
    {
      product: "Side Table",
      dims: [
        "2925px x 2925px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Square Tray",
      dims: [
        "3450px x 3450px",
        "4650px x 4650px"
      ],
      opts: [
  		'M',
        'L'
      ],
      opt: "0",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Throw Blanket",
      dims: [
        "7800px x 9300px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Throw Pillow",
      dims: [
        "2625px x 2625px",
        "2925px x 2925px",
        "3225px x 3225px",
        "4125px x 4125px"
      ],
      opts: [
  		'16" x 16"',
        '18" x 18"',
        '20" x 20"',
        '26" x 26"'
      ],
      opt: "1",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Wood Wall Mural",
      dims: [
        "5250px x 5250px",
        "7215px x 7215px",
        "8790px x 8790px",
      ],
      opts: [
  		"3' x 3' (Nine 12\" Wood Squares)",
        "4' x 4' (Nine 16\" Wood Squares)",
        "5' x 5' (Nine 20\" wood Squares)"
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Bar Stool",
      dims: [
        "2628px x 2628px"
      ],
      opts: [
  		
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Credenza",
      dims: [
        "5295px x 3300px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Framed Mini Art Print",
      dims: [
        "938px x 1238px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Outdoor Throw Pillow",
      dims: [
        "2625px x 2625px",
        "2925px x 2925px",
        "3225px x 3225px",
        "4125px x 4125px"
      ],
      opts: [
  		'16" x 16"',
        '18" x 18"',
        '20" x 20"',
        '26" x 26"'
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Poster",
      dims: [
        "5437px x 7237px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Round Side Table",
      dims: [
        "3000px x 3000px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Sheer Window Curtain",
      dims: [
        "1800px x 1800px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Wall Hanging Landscape",
      dims: [
        "4254px x 3039px",
        "7800px x 5572px"
      ],
      opts: [
  		'Small',
        'Large'
      ],
      opt: "0",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Wall Hanging Portrait",
      dims: [
        "2064px x 2889px",
        "4058px x 5678px"
      ],
      opts: [
  		'Small',
        'Large'
      ],
      opt: "0",
      dpi: "150",
      orientation: "orientation"
    },
    {
      product: "Wall Mural",
      dims: [
        "7200px x 7200px",
        "10800px x 7200px"
      ],
      opts: [
  		'8ft x 8ft',
        '12ft x 8ft'
      ],
      opt: "0",
      dpi: "75",
      orientation: "both"
    },
    {
      product: "Wallpaper",
      dims: [
        "3600px x 3600px",
        "3600px x 3600px",
        "3600px x 3600px"
      ],
      opts: [
  		'2ft x 4ft panel',
        '2ft x 8ft panel',
        '2ft x 10ft panel'
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Welcome Mat",
      dims: [
        "4650px x 3150px",
        "5550px x 3750px"
      ],
      opts: [
  		'20" x 30"',
        '24" x 36"'
      ],
      opt: "0",
      dpi: "150",
      orientation: "landscape"
    },
    {
      product: "Area Rug",
      dims: [
        "2600px x 3800px",
        "5000px x 7400px",
        "6200px x 8600px",
        "9800px x 12200px",
        "9800px x 14592px",
      ],
      opts: [
  		"2' x 3'",
        "4' x 6'",
        "5' x 7'",
        "8' x 10'",
        "8' x 12'"
      ],
      opt: "0",
      dpi: "100",
      orientation: "both"
    },
    {
      product: "Outdoor Rug",
      dims: [
        "2600px x 3800px",
        "5000px x 7400px",
        "6200px x 8600px",
        "9800px x 12200px",
        "9800px x 14592px",
      ],
      opts: [
  		"2' x 3'",
        "4' x 6'",
        "5' x 7'",
        "8' x 10'",
        "8' x 12'"
      ],
      opt: "0",
      dpi: "100",
      orientation: "both"
    },
    {
      product: "Travel Mug",
      dims: [
        "2795px x 2100px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "landscape"
    },
    {
      product: "Spiral Notebook",
      dims: [
        "3875px x 2475px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Yoga Mat",
      dims: [
        "3750px x 10650px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "portrait"
    },
    {
      product: "Water Bottle",
      dims: [
        "2759px x 1500px",
        "2760px x 1996px",
        "3390px x 2232px"
      ],
      opts: [
  		'12 oz (356 ml)',
        '18 oz (532 ml)',
        '32 oz (946 ml)'
      ],
      opt: "0",
      dpi: "300",
      orientation: "landscape"
    },
    {
      product: "Phone Case",
      dims: [
        "1300px x 2000px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "landscape"
    },
    {
      product: "Sling Chair",
      dims: [
        "2550px x 7800px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Folding Stool",
      dims: [
        "2250px x 2700px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Picnic Blanket",
      dims: [
        "7750px x 9300px"
      ],
      opts: [
  
      ],
      opt: "",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Beach Towel",
      dims: [
        "11400px x 22200px"
      ],
      opts: [
  
      ],
      opt: "n",
      dpi: "300",
      orientation: "portrait"
    },
    {
      product: "Yoga Towel",
      dims: [
        "22500px x 7500px"
      ],
      opts: [
  
      ],
      opt: "0",
      dpi: "150",
      orientation: "portrait"
    },
    {
      product: "Wine Chiller",
      dims: [
        "4476px x 2197px"
      ],
      opts: [
  
      ],
      opt: "0",
      dpi: "300",
      orientation: "landscape"
    },
    {
      product: "Floating Acrylic Print",
      dims: [
        "1560px x 2097px",
        "2100px x 2100px",
        "2550px x 3399px",
        "3885px x 5181px",
        "4200px x 4200px",
        "5118px x 6825px",
        "6600px x 6600px",
      ],
      opts: [
  		'8" x 10"',
        '10" x 10"',
        '13" x 19"',
        '18" x 24"',
        '20" x 20"',
        '24" x 36"',
        '30" x 30"',
      ],
      opt: "0",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Recessed Framing Rectangle",
      dims: [
        "1800px x 2400px",
        "3000px x 4800px",
        "4200px x 6000px",
        "5400px x 9000px",
      ],
      opts: [
  		'8"x10"',
        '13"x19"',
        '18"x24"',
        '24"x36"',
      ],
      opt: "1",
      dpi: "300",
      orientation: "both"
    },
    {
      product: "Recessed Framing Square",
      dims: [
        "3000px x 3000px",
        "6000px x 6000px"
      ],
      opts: [
  		'10"x10"',
        '20"x20"'
      ],
      opt: "1",
      dpi: "300"
    },
    {
      product: "Tablecloth",
      dims: [
        "5760px x 9984px"
      ],
      opts: [
  
      ],
      opt: "0",
      dpi: "96",
      orientation: "both"
    },
    {
      product: "Table Runner",
      dims: [
        "2625px x 13725px"
      ],
      opts: [
  
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    },
    {
      product: "Placemat",
      dims: [
        "2400px x 3000px"
      ],
      opts: [
  
      ],
      opt: "0",
      dpi: "150",
      orientation: "both"
    }
  ]